import { Grid, Typography, useTheme } from "@mui/material";
import FieldDetails from "./FieldDetails";
import CustomCard from "../../../components/@extended/CustomCard";
import { SKIPPED_FIELDS_KEY } from "../../../util/constants";

const FieldList = (props) => {
    const { fieldArr, parentKey, answers, userSiteTrialRole } = props;
    const theme = useTheme();
    const INVALID_FIELDS = [ 'DATA_HTML', 'FILE_UPLOAD', 'BUTTON'];
    const VALID_FIELDS = ['INLINE_TEXT_FIELD', 'DROP_DOWN', 'RADIO_BUTTONS', 'VIDEO_LINK', 'DOCUMENT_LINK', 'CHECK_BOX_GROUP', 'CHECK_BOX', 'SLIDER', 'COLOUR_SLIDER', 'PHONE_INPUT', 'LABEL', 'FILE_UPLOAD', "SIGNATURE", 'DATA_LABEL'];
    
    const dependsOnAnswerCheck = (dependsOn, dependsValue) => {
      if (dependsOn.includes('.')) {
        const keys = dependsOn.split('.');
        return answers && answers[keys[0]] && answers[keys[0]][keys[1]] && answers[keys[0]][keys[1]] === dependsValue;
      } else {
        return answers[dependsOn] === dependsValue;
      }
    };
    return (<>
        {answers && fieldArr &&
            fieldArr.map((field, index) => (
                VALID_FIELDS.includes(field.type) && !SKIPPED_FIELDS_KEY.includes(field.key) && (!field.dependsOn || (field.dependsOn && dependsOnAnswerCheck(field.dependsOn, field.dependsValue))) && (!field.access || (field.access && field.access == userSiteTrialRole)) &&
                (<Grid item md={(field.textFontWeight || field.tableRow) ? field.md : 6} lg={(field.textFontWeight || field.tableRow) ? field.lg : 6} sm={6} xs={12} key={`field${index}`} sx={{ borderBottom: '1px solid #E7E7E7', paddingY: '16px !important' }}>
                    <FieldDetails {...props} key={field.label} 
                        allAnswers={answers[parentKey] ? answers[parentKey] : answers}  
                        signDate={answers[parentKey] ? answers[parentKey][field.currentDateKey] : answers[field.currentDateKey]}
                        details={field} 
                        answer={answers[parentKey] ? answers[parentKey][field.key] : answers[field.key]}
                    />
                    {field.fields && <Grid container spacing={2} sx={{ marginTop: 1 }}>
                        {
                            field.fields.map((childField, childIndex) => (
                                VALID_FIELDS.includes(childField.type) && !SKIPPED_FIELDS_KEY.includes(childField.key) &&(!childField.dependsOn || (childField.dependsOn && dependsOnAnswerCheck(childField.dependsOn, childField.dependsValue)))&&
                                (!childField.access || (childField.access && childField.access == userSiteTrialRole))
                                && <Grid key={parentKey ? `${parentKey}.${childIndex}.${index}` : `aa${childIndex}${index}`}
                                    item md={12} sm={12} xs={12}>
                                    <FieldDetails {...props} key={childField.label} 
                                        allAnswers={answers[parentKey] ? answers[parentKey] : answers} 
                                        signDate={answers[parentKey] ? answers[parentKey][childField.currentDateKey] : answers[childField.currentDateKey]}
                                        details={childField} 
                                        answer={answers[parentKey] ? answers[parentKey][childField.key] : answers[childField.key]}
                                    />
                                </Grid>
                            ))
                        }
                    </Grid>}
                </Grid>)
            ))}
    </>)
}
export default FieldList;